import React, { useEffect, useState } from "react";
import AgencySideBar from "../Components/AgencySideBar";
import Navbar, { Navtopbar } from "../../Components/Navbar";
import AppointmentSettingsclinic from "./AppointmentSettingsclinic";
import GeneralSettingsAgency from "./GeneralSettingsAgency";
import UserSettings from "./UserSettings";
import ClinicalSettings from "./ClinicalSettings";
import { useLocation, useNavigate } from "react-router-dom";
import Credentials from "./Credentials";
import AddAddress from "./AddAddress";
import ProviderType from "./ProviderType";
import Services from "./Services";
import BookingServices from "./BookingServices";
import ConditionTreated from "./ConditionTreated";
import Specialties from "./Specialties";
import DeliveryMode from "./DeliveryMode";
import PaymentSources from "./PaymentSources";
import PopulationServed from "./PopulationServed";
import ModalitiesScreen from "./ModalitiesScreen";
import InsuranceScreen from "./InsuranceScreen";
import LanguageScreen from "./LanguageScreen";
import SubscriptionScreen from "./SubscriptionScreen";
import AgencyPlanManagement from "./AgencyPlanManagement";
import NewAppointment from "./NewAppointment";
import AppointmentVisitStatus from "./AppointmentVisitStatus";
import VisitReason from "./VisitReason";
import AgencySubscriptionModules from "./AgencySubscriptionModules";
import ClientRequirements from "./ClientRequirements";
import DegreeType from "./DegreeType";
import AddContract from "./AddContract";
import NewModule from "./NewModule";
import AddQuestion from "./AddQuestion";
import AddCategory from "./AddCategory";
import AddNewQuestionnaire from "./AddNewQuestionnaire";
import QuestionnaireList from "./QuestionnaireList";
import QuestionCategoryList from "./QuestionCategoryList";
import ConsentManagement from "./ConsentManagement";
import MeasurementManagement from "./Patientinfoeditscreens/MeasurmentManagement";
import Billing from "./Billing/Billing";
import Practice from "./Practice";
import PrivatePay from "./PrivatePay";
import { useSelector } from "react-redux";
import { GetSettingCheck } from "../../../api/helper";
import Conditionsagencysetting from "./Conditionsagencysetting";
import ClinicalTemplates from "./ClinicalTemplates";
import FormBuilder from "./FormBuilder";
import LabsIntegration from "./LabsIntegration";
import EPrescription from "./EPrescription";
import AppointmentResources from "./AppointmentResources";

const Settingss = () => {
  // const [activeTab, setActiveTab] = useState("general");
  const profiledata = useSelector((state) => state?.cookies?.userDetails);
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const [checkingdata, setcheckingdata] = useState({});
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("activeTab") || "general"
  );
  useEffect(() => {
    if (queryParams.get("ConfigureStripe") === "true") {
      setActiveTab("Billing");
    }
  }, [queryParams]);
  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
  }, [activeTab]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const GetTabStatus = async () => {
    try {
      const respo = await GetSettingCheck(profiledata?._id);
      setcheckingdata(respo?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetTabStatus();
  }, []);
  const isTabCompleted = (key) => checkingdata?.[key] > 0;
  // console.log(checkingdata,"checkingdata=-=-=")
  return (
    <div className="dashboard-container">
      <AgencySideBar />
      <div className="dashboard-content">
        <Navtopbar
          onClick={() => {
            navigate("/MyProfileAgency");
          }}
          title="Settings"
        />

        <div
          // className="dashboard-cards"
          style={{ paddingLeft: 30, paddingRight: 30, flexDirection: "column" }}
        >
          <>
            <h1>Settings Dashboard</h1>

            <div className="section-box">
              <h2 style={{ textAlign: "left" }}>Agency System &amp; Profile</h2>
              <div className="tab-bar">
                <button
                  className={`tab-button_two ${
                    activeTab === "general" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("general")}
                >
                  <i className="fas fa-cogs" /> General Settings
                  <i class="fas fa-check-circle"></i>
                </button>

                <button
                  className={`tab-button_two ${
                    activeTab === "UserSettings" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("UserSettings")}
                >
                  <i className="fas fa-users-cog" /> User Settings
                </button>

                <button
                  className={`tab-button_two ${
                    activeTab === "Billing" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("Billing")}
                >
                  <i className="fab fa-stripe-s" /> Connect Stripe
                  {profiledata?.isConnctedStripe && (
                    <i class="fas fa-check-circle"></i>
                  )}
                </button>

                <button
                  className={`tab-button_two ${
                    activeTab === "ClinicalTemplates" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("ClinicalTemplates")}
                >
                  <i className="fas fa-file-medical-alt" /> Clinical Templates
                </button>

                <button
                  className={`tab-button_two ${
                    activeTab === "FormBuilder" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("FormBuilder")}
                >
                  <i className="fas fa-wrench" /> Form Builder
                </button>

                <button
                  className={`tab-button_two ${
                    activeTab === "PaymentSources" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("PaymentSources")}
                >
                  <i className="fas fa-credit-card" /> Payment Sources
                  {isTabCompleted("PaymentSources") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>

                <button
                  className={`tab-button_two ${
                    activeTab === "InsuranceScreen" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("InsuranceScreen")}
                >
                  <i className="fas fa-notes-medical" /> Insurance
                  {isTabCompleted("Insurance") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>

                <button
                  className={`tab-button_two ${
                    activeTab === "SubscriptionScreen" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("SubscriptionScreen")}
                >
                  <i className="fas fa-server" /> Subscription Plans
                  {isTabCompleted("Subscription") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>

                <button
                  className={`tab-button_two ${
                    activeTab === "AddContract" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("AddContract")}
                >
                  <i className="fas fa-file-contract" /> Payer Contract
                  {isTabCompleted("InsuranceContract") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>

                <button
                  className={`tab-button_two ${
                    activeTab === "AgencyPlanManagement" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("AgencyPlanManagement")}
                >
                  <i className="fas fa-layer-group" /> Agency Plan Management
                  {isTabCompleted("planSubscription") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>

                <button
                  className={`tab-button_two ${
                    activeTab === "LabsIntegration" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("LabsIntegration")}
                >
                  <i className="fas fa-vial" /> Labs Integration
                </button>

                <button
                  className={`tab-button_two ${
                    activeTab === "EPrescription" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("EPrescription")}
                >
                  <i class="fas fa-prescription-bottle-alt" /> E-Prescription
                </button>
              </div>
              <div
                className="dashboard-cards"
                style={{
                  flexDirection: "column",
                  paddingBottom: 0,
                }}
              >
                {activeTab === "EPrescription" && <EPrescription />}
                {activeTab === "LabsIntegration" && <LabsIntegration />}
                {activeTab === "FormBuilder" && <FormBuilder />}
                {activeTab === "ClinicalTemplates" && <ClinicalTemplates />}
                {activeTab === "general" && <GeneralSettingsAgency />}
                {activeTab === "UserSettings" && <UserSettings />}
                {activeTab === "Billing" && <Billing />}
                {activeTab === "PaymentSources" && (
                  <PaymentSources GetTabStatus={GetTabStatus} />
                )}
                {activeTab === "InsuranceScreen" && (
                  <InsuranceScreen GetTabStatus={GetTabStatus} />
                )}
                {activeTab === "SubscriptionScreen" && (
                  <SubscriptionScreen GetTabStatus={GetTabStatus} />
                )}
                {activeTab === "AddContract" && (
                  <AddContract GetTabStatus={GetTabStatus} />
                )}
                {activeTab === "AgencyPlanManagement" && (
                  <AgencyPlanManagement GetTabStatus={GetTabStatus} />
                )}
              </div>
            </div>

            <div className="section-box">
              <h2 style={{ textAlign: "left" }}>Provider Settings</h2>
              <div className="tab-bar">
                <button
                  className={`tab-button_two ${
                    activeTab === "CalendarSettings" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("CalendarSettings")}
                >
                  <i className="fas fa-calendar-alt" /> Calendar Settings
                </button>
                <button
                  className={`tab-button_two ${
                    activeTab === "NewAppointment" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("NewAppointment")}
                >
                  <i className="fas fa-clone" /> Appointment Types
                  {isTabCompleted("AppointmentType") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>

                <button
                  className={`tab-button_two ${
                    activeTab === "AppointmentVisitStatus" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("AppointmentVisitStatus")}
                >
                  <i className="fas fa-tasks" /> Visit Status
                  {isTabCompleted("AppointmentVisit") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>

                <button
                  className={`tab-button_two ${
                    activeTab === "VisitReason" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("VisitReason")}
                >
                  <i className="fas fa-question-circle" /> Visit Reason
                  {isTabCompleted("VisitReason") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>  
                 <button
                  className={`tab-button_two ${
                    activeTab === "AppointmentResources" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("AppointmentResources")}
                >
                  <i className="fas fa-question-circle" /> Appointment Resources
                  {isTabCompleted("AppointmentResources") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>
                <button
                  className={`tab-button_two ${
                    activeTab === "ProviderType" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("ProviderType")}
                >
                  <i className="fas fa-user-md" /> Provider Type
                  {isTabCompleted("ProvideType") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>
                <button
                  className={`tab-button_two ${
                    activeTab === "DegreeType" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("DegreeType")}
                >
                  <i className="fas fa-graduation-cap" /> Degree Type
                  {isTabCompleted("DegreeType") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>
                <button
                  className={`tab-button_two ${
                    activeTab === "Credentials" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("Credentials")}
                >
                  <i class="fas fa-clipboard-check"></i> Requirements
                  {isTabCompleted("providerRequirement") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>
                <button
                  className={`tab-button_two ${
                    activeTab === "ClinicalSettings" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("ClinicalSettings")}
                >
                  <i className="fas fa-sliders-h" /> Clinical Settings
                  {isTabCompleted("getProfile") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>
                {/* <button
                  className={`tab-button_two ${
                    activeTab === "Conditions" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("Conditions")}
                >
                  <i className="fas fa-heartbeat" /> Conditions
                </button> */}
                <button
                  className={`tab-button_two ${
                    activeTab === "ConditionTreated" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("ConditionTreated")}
                >
                  <i className="fas fa-heartbeat" /> Condition
                  {isTabCompleted("ConditionTreated") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>
                <button
                  className={`tab-button_two ${
                    activeTab === "Specialties" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("Specialties")}
                >
                  <i className="fas fa-user-nurse" /> Specialties
                  {isTabCompleted("Specialties") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>
                <button
                  className={`tab-button_two ${
                    activeTab === "Modalities" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("Modalities")}
                >
                  <i className="fas fa-brain" /> Modalities
                  {isTabCompleted("Modalities") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>
                <button
                  className={`tab-button_two ${
                    activeTab === "PopulationServed" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("PopulationServed")}
                >
                  <i className="fas fa-users" /> Populations
                  {isTabCompleted("PopulationServed") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>
                <button
                  className={`tab-button_two ${
                    activeTab === "Languages" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("Languages")}
                >
                  <i className="fas fa-language" /> Languages
                  {isTabCompleted("Languages") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>
              </div>
              <div
                className="dashboard-cards"
                style={{
                  flexDirection: "column",
                  paddingBottom: 0,
                }}
              >
                {activeTab === "Credentials" && (
                  <Credentials GetTabStatus={GetTabStatus} />
                )}
                {activeTab === "CalendarSettings" && (
                  <AppointmentSettingsclinic />
                )}
                {activeTab === "NewAppointment" && (
                  <NewAppointment GetTabStatus={GetTabStatus} />
                )}
                {activeTab === "AppointmentVisitStatus" && (
                  <AppointmentVisitStatus GetTabStatus={GetTabStatus} />
                )}
                {activeTab === "VisitReason" && (
                  <VisitReason GetTabStatus={GetTabStatus} />
                )}
                {activeTab === "ProviderType" && (
                  <ProviderType GetTabStatus={GetTabStatus} />
                )}
                {activeTab === "DegreeType" && (
                  <DegreeType GetTabStatus={GetTabStatus} />
                )}

                {activeTab === "ClinicalSettings" && (
                  <ClinicalSettings GetTabStatus={GetTabStatus} />
                )}
                {/* {activeTab === "Conditions" && (
                  <Conditionsagencysetting  />
                )} */}
                {activeTab === "ConditionTreated" && (
                  <ConditionTreated GetTabStatus={GetTabStatus} />
                )}
                {activeTab === "Specialties" && (
                  <Specialties GetTabStatus={GetTabStatus} />
                )}
                {activeTab === "Modalities" && (
                  <ModalitiesScreen GetTabStatus={GetTabStatus} />
                )}
                {activeTab === "PopulationServed" && (
                  <PopulationServed GetTabStatus={GetTabStatus} />
                )}
                {activeTab === "Languages" && (
                  <LanguageScreen GetTabStatus={GetTabStatus} />
                )
                }
                 {activeTab === "AppointmentResources" && (
                  <AppointmentResources GetTabStatus={GetTabStatus} />
                )}
              </div>
            </div>
            <div className="section-box">
              <h2 style={{ textAlign: "left" }}>Client Services</h2>
              <div className="tab-bar">
                <button
                  className={`tab-button_two ${
                    activeTab === "Services" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("Services")}
                >
                  <i className="fas fa-concierge-bell" /> Services
                  {isTabCompleted("TreatmentTypes") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>
                <button
                  className={`tab-button_two ${
                    activeTab === "DeliveryMode" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("DeliveryMode")}
                >
                  <i class="fas fa-laptop-medical"></i> Delivery Modes
                  {isTabCompleted("DeliveryMode") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>
                <button
                  className={`tab-button_two ${
                    activeTab === "ServiceAddress" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("ServiceAddress")}
                >
                  <i class="fas fa-map-marker-alt"></i> Service Address
                  {isTabCompleted("ServiceLocation") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>
                <button
                  className={`tab-button_two ${
                    activeTab === "ConsentManagement" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("ConsentManagement")}
                >
                  <i class="fas fa-file-signature"></i> Consents
                  {isTabCompleted("ConsentManagement") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>
                <button
                  className={`tab-button_two ${
                    activeTab === "MeasurementManagement" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("MeasurementManagement")}
                >
                  <i class="fas fa-ruler"></i> Measures
                  <i class="fas fa-check-circle"></i>
                </button>
                <button
                  className={`tab-button_two ${
                    activeTab === "ClientRequirements" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("ClientRequirements")}
                >
                  <i className="fas fa-clipboard-check" /> Requirements
                  {isTabCompleted("ClientRequirement") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>

                <button
                  className={`tab-button_two ${
                    activeTab === "Practice" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("Practice")}
                >
                  <i class="fas fa-user-friends"></i> Care Team
                  {isTabCompleted("FacilityExternalTeam") && (
                    <i className="fas fa-check-circle" />
                  )}
                </button>
              </div>
              <div
              
                style={{
                  flexDirection: "column",
                  paddingBottom: 0,
                }}
              >
                {activeTab === "ClientRequirements" && (
                  <ClientRequirements GetTabStatus={GetTabStatus} />
                )}

                {activeTab === "ServiceAddress" && (
                  <AddAddress GetTabStatus={GetTabStatus} />
                )}

                {activeTab === "BookingServices" && <BookingServices />}
                {activeTab === "Services" && (
                  <Services GetTabStatus={GetTabStatus} />
                )}

                {activeTab === "DeliveryMode" && (
                  <DeliveryMode GetTabStatus={GetTabStatus} />
                )}

                {activeTab === "PrivatePay" && <PrivatePay />}

                {activeTab === "AgencySubscriptionModules" && (
                  <AgencySubscriptionModules />
                )}

                {activeTab === "MeasurementManagement" && (
                  <MeasurementManagement />
                )}

                {activeTab === "AddNewQuestionnaire" && <AddNewQuestionnaire />}
                {activeTab === "QuestionnaireList" && <QuestionnaireList />}
                {activeTab === "QuestionCategoryList" && (
                  <QuestionCategoryList />
                )}
                {activeTab === "ConsentManagement" && (
                  <ConsentManagement GetTabStatus={GetTabStatus} />
                )}

                {activeTab === "Practice" && <Practice />}
              </div>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default Settingss;
